import React, { Fragment } from 'react';

import './QuestionForm.css';
import FroalaEditor from 'react-froala-wysiwyg';
import { froalaConfig, withFroalaLicense } from '../../../utils/froalaConfig';

// Flat toolbar list so MathType/WIRIS buttons are always visible (not hidden in "more" menus).
const optionToolbarButtons = [
	'bold',
	'italic',
	'underline',
	'strikeThrough',
	'subscript',
	'superscript',
	'fontFamily',
	'fontSize',
	'textColor',
	'backgroundColor',
	'clearFormatting',
	'|',
	'alignLeft',
	'alignCenter',
	'alignRight',
	'alignJustify',
	'formatOL',
	'formatUL',
	'paragraphFormat',
	'lineHeight',
	'|',
	'insertLink',
	'insertImage',
	'insertVideo',
	'insertTable',
	'insertFile',
	'emoticons',
	'specialCharacters',
	'|',
	'wirisEditor',
	'wirisChemistry',
	'|',
	'undo',
	'redo',
	'fullscreen',
	'html',
];

const buildOptionEditorConfig = (overrides = {}) =>
	withFroalaLicense({
	  ...froalaConfig,
	  height: 200,
	  ...overrides,
	});

const QuestionForm = (props) => {
	const currentSubject = props.subject;
	const isAddButtonDisabled = props.formList.length >= 5;
	// alert(currentSubject);
	return props?.formList?.map((val, idx) => {
		let questionTitle = `questionTitle-${idx}`,
			option1 = `option1-${idx}`,
			option2 = `option2-${idx}`,
			option3 = `option3-${idx}`,
			option4 = `option4-${idx}`,
			option5 = `option5-${idx}`,
			rightAnswer = `rightAnswer-${idx}`,
			answerDesc = `answerDesc-${idx}`;
		// index = val.index;
		// alert(val.rightAnswer)
		return (
			<Fragment key={val.index}>
				<div className="question-row">
					{props.passage_check && (
						<div className="form-group row">
							<div className="col-md-12">
								<label htmlFor={questionTitle}>Question {idx + 1}</label>

								{/* <input
									type="text"
									name="questionTitle"
									className="form-control"
									id={questionTitle}
									data-id={idx}
									placeholder="Enter question"
									onChange={props.handleChange}
								// value={val.questionTitle ? val.questionTitle : ""}
								/> */}

								<FroalaEditor
									tag='textarea'
									model={val.questionTitle ?? ''}
									onModelChange={(content) => props.changeLinkedQuestionText('questionTitle', idx, content)}
									config={buildOptionEditorConfig()}
								/>
							</div>
						</div>
					)}

					<div className="form-group row">
						<div className="col-md-12">
							<label htmlFor={option1}>Option 1</label>
							{/* <input
								type="text"
								name="option1"
								className="form-control"
								id={option1}
								data-id={idx}
								placeholder="Enter option 1"
								onChange={props.handleChange}
								required
							//value={val.option1 ? val.option1 : ""}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.option1 ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('option1', idx, content)}
								config={buildOptionEditorConfig()}
							/>



							<div className="checkbox">
								<label htmlFor={`${option1}-${rightAnswer}`}>
									<input
										type="checkbox"
										name={rightAnswer}
										id={`${option1}-${rightAnswer}`}
										data-id={idx}
										value={1}
										onChange={props.handleAnswerChange}
										checked={val.rightAnswer == 1}
									/>
									{' '}Correct Answer
								</label>
							</div>
						</div>

						<div className="col-md-12">
							<label htmlFor="option_2">Option 2.</label>
							{/* <input
								type="text"
								name="option2"
								className="form-control"
								id={option2}
								data-id={idx}
								placeholder="Enter Option 2"
								onChange={props.handleChange}
								required
							// value={val.option2}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.option2 ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('option2', idx, content)}
								config={buildOptionEditorConfig()}
							/>
							<div className="checkbox">
								<label htmlFor={`${option2}-${rightAnswer}`}>
									<input
										type="checkbox"
										name={rightAnswer}
										id={`${option2}-${rightAnswer}`}
										data-id={idx}
										value={2}
										onChange={props.handleAnswerChange}
										checked={val.rightAnswer == 2}
									/>
									{' '}Correct Answer
								</label>
							</div>
						</div>
					</div>
					<div className="form-group row">
						<div className="col-md-12">
							<label htmlFor="option_3">Option 3</label>
							{/* <input
								type="text"
								name="option3"
								className="form-control"
								id={option3}
								data-id={idx}
								placeholder="Enter option 3"
								onChange={props.handleChange}
								required
							//value={val.option3}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.option3 ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('option3', idx, content)}
								config={buildOptionEditorConfig()}
							/>
							<div className="checkbox">
								<label htmlFor={`${option3}-${rightAnswer}`}>
									<input
										type="checkbox"
										name={rightAnswer}
										id={`${option3}-${rightAnswer}`}
										data-id={idx}
										value={3}
										onChange={props.handleAnswerChange}
										checked={val.rightAnswer == 3}
									/>
									{' '}Correct Answer
								</label>
							</div>
						</div>
						<div className="col-md-12">
							<label htmlFor="option_2">Option 4</label>
							{/* <input
								type="text"
								name="option4"
								className="form-control"
								id={option4}
								data-id={idx}
								placeholder="Enter Option 4"
								onChange={props.handleChange}
								required
							//value={val.option4}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.option4 ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('option4', idx, content)}
								config={buildOptionEditorConfig()}
							/>

							<div className="checkbox">
								<label htmlFor={`${option4}-${rightAnswer}`}>
									<input
										type="checkbox"
										name={rightAnswer}
										id={`${option4}-${rightAnswer}`}
										data-id={idx}
										value={4}
										onChange={props.handleAnswerChange}
										checked={val.rightAnswer == 4}
									/>
									{' '}Correct Answer
								</label>
							</div>
						</div>
					</div>
					<div className="form-group row">
						<div className="col-md-12">
							<label htmlFor="option_2">Option 5</label>
							{/* <input
								type="text"
								name="option5"
								className="form-control"
								id={option5}
								data-id={idx}
								placeholder="Enter Option 5"
								onChange={props.handleChange}
							//value={val.option5}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.option5 ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('option5', idx, content)}
								config={buildOptionEditorConfig()}
							/>
							<div className="checkbox">
								<label htmlFor={`${option5}-${rightAnswer}`}>
									<input
										type="checkbox"
										name={rightAnswer}
										id={`${option5}-${rightAnswer}`}
										data-id={idx}
										value={5}
										onChange={props.handleAnswerChange}
										checked={val.rightAnswer == 5}
									/>
									{' '}Correct Answer
								</label>
							</div>
						</div>
					</div>
					<div className="form-group row">
						<div className="col-md-12">
							<label htmlFor="description">Description</label>
							{/* <textarea
								type="text"
								name="answerDesc"
								className="form-control"
								id={answerDesc}
								data-id={idx}
								placeholder="Enter the description for correct answer"
								onChange={props.handleChange}
								required
							//value={val.answerDesc}
							/> */}
							<FroalaEditor
								tag='textarea'
								model={val.answerDesc ?? ''}
								onModelChange={(content) => props.changeLinkedQuestionText('answerDesc', idx, content)}
								config={buildOptionEditorConfig()}
							/>
						</div>
						{true && (
							<div className="col-md-12">
								<br />
								{/* {idx === 0 ? ( */}
								{idx == props?.formList?.length - 1 && <button
									onClick={() => props.add()}
									style={{ margin: '12px' }}
									type="button"
									className="btn btn-primary pull-right"
									title="Add more question for this passage"
									disabled={isAddButtonDisabled || !props.passage_check}
								>
									<i className="fa fa-plus-circle" aria-hidden="true" />
								</button>}
								<button
									style={{ margin: '12px' }}
									className="btn btn-danger pull-right"
									onClick={() => props.delete(val)}
									title="Delete"
									disabled={idx == 0 || !props.passage_check}
								>
									<i className="fa fa-minus" aria-hidden="true" />
								</button>
								{/* )} */}
							</div>
						)}
					</div>
				</div>
			</Fragment>
		);
	});
};

export default QuestionForm;


